module.exports = __webpack_public_path__ + "media/images/lb/905-0768cdd8a8146c23e56c1635279b6440.svg";